<template>
    <div class="uk-padding uk-background-muted">
        <h1 class="uk-heading-line uk-text-center">Client Stories & Testimonials</h1>

        <br>
       <div class="uk-container uk-container-small">
           <div uk-slider=" autoplay: true; autoplay-interval: 3000">

               <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1">

                   <ul class="uk-slider-items uk-child-width-1-1@s uk-grid" >
                       <li>
                           <div class="uk-card uk-card-default">
                               <div class="uk-card uk-card-default uk-width-1-1@m">
                                   <div class="uk-card-header">
                                       <div class="uk-grid-small uk-flex-middle" uk-grid>
                                           <div class="uk-width-auto@s">
                                               <img class="uk-border-circle" width="100" height="100" src="../../../../public/fincor_lion.png">
                                           </div>
                                           <div class="uk-width-expand@s">
                                               <h5 class=" uk-margin-remove-bottom" style="color: #333 !important;">
                                                   Client in the health sector  with annual revenues exceeding $100 million. Has been in
                                                   existence for over 15 years, but had never received a clean audit.
                                               </h5>
                                               <p class="uk-text-meta uk-margin-remove-top"><time datetime="2016-04-01T19:00">April 01, 2016</time></p>
                                           </div>
                                       </div>
                                   </div>
                                   <div class="uk-card-body " style="margin-top: -15px !important; margin-bottom: -15px !important;" >
                                       <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">How FINCOR was able to help?</h5>
                                       <p>
                                           We took over as interim CFO for the organization; reviewed and updated
                                           financial policies and procedures; trained staff; managed implementation of enhanced controls;
                                           provided leadership to the finance team; documented approach to the adoption of new IFRS accounting
                                           standards; assisted with the recruitment of a permanent CFO; and worked with staff throughout the
                                           audit process.
                                       </p>
                                   </div>
                                   <div class="uk-card-footer">
                                       <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">Outcome</h5>
                                       <p>
                                           Client received a clean audit for the first time in their history. The fiscal year closed with the
                                           highest recorded revenue for a 12-month period, and the highest recorded closing cash balance.
                                           Following the preparation of a business case using the UK Treasury’s 5-case model
                                         <label for="" style="color: #888">(prepared by FINCOR)</label>, client was able to
                                           finance the acquisition of new building facilities, and is presently working on the expansion of their
                                           service offerings.
                                       </p>
                                   </div>
                               </div>
                           </div>
                       </li>
                       <li>
                           <div class="uk-card uk-card-default">
                               <div class="uk-card uk-card-default uk-width-1-1@m">
                                   <div class="uk-card-header">
                                       <div class="uk-grid-small uk-flex-middle" uk-grid>
                                           <div class="uk-width-auto">
                                               <img class="uk-border-circle" width="100" height="100" src="../../../../public/fincor_lion.png">
                                           </div>
                                           <div class="uk-width-expand">
                                               <h5 class=" uk-margin-remove-bottom" style="color: #333 !important;">
                                                   Client in the technology sector with annual revenue of over $1.5 million. Has been in
                                                   existence for almost 20 years; however, due to the unexpected resignation of key finance staff,
                                                   management was unable to get key financial information on the business due to reporting and
                                                   reconciliation being several months behind.
                                               </h5>

                                           </div>
                                       </div>
                                   </div>
                                   <div class="uk-card-body " style="margin-top: -15px !important; margin-bottom: -15px !important;" >
                                       <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">How FINCOR was able to help?</h5>
                                       <p>
                                           We provided an ACCA qualified staff to take over the financial
                                           management of the business on an outsourced basis. We quickly got accounts reconciled, made
                                           necessary corrections, and brought the reporting standard up to date.
                                       </p>
                                   </div>
                                   <div class="uk-card-footer">
                                       <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">Outcome</h5>
                                       <p>
                                           Client receives detailed reports monthly within 15 days of month end; was able to reduce the
                                           cost of accounting services by over 35%; satisfied the reporting requirements of external stakeholders;
                                           and no longer has to worry about the performance of this area of business operations.
                                       </p>
                                   </div>
                               </div>
                           </div>
                       </li>
                       <li>
                           <div class="uk-card uk-card-default">
                               <div class="uk-card uk-card-default uk-width-1-1@m">
                                   <div class="uk-card-header">
                                       <div class="uk-grid-small uk-flex-middle" uk-grid>
                                           <div class="uk-width-auto">
                                               <img class="uk-border-circle" width="100" height="100" src="../../../../public/fincor_lion.png">
                                           </div>
                                           <div class="uk-width-expand">
                                               <h5 class=" uk-margin-remove-bottom" style="color: #333 !important;">
                                                   Non-profit organization with annual revenues circa $1 million. Client had no financial
                                                   record system, had difficulty in producing reports to key stakeholders, and was unable to meet audit
                                                   standards or requirements.
                                               </h5>

                                           </div>
                                       </div>
                                   </div>
                                   <div class="uk-card-body " style="margin-top: -15px !important; margin-bottom: -15px !important;" >
                                       <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">How FINCOR was able to help?</h5>
                                       <p>
                                           We took over as accountants for the organization and fully set up the
                                           accounting records and system to improve reporting and accountability. As an independent
                                           organization, we assisted in improving the confidence of donor organizations to support the entity; we
                                           prepared periodic and annual reports for managing committees and grant organizations; and assisted
                                           the organization through its first audit.
                                       </p>
                                   </div>
                                   <div class="uk-card-footer">
                                       <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">Outcome</h5>
                                       <p>
                                           The organization’s records are now maintained and reported on independently, and
                                           management and the Executive Committee now receive timely and accurate information on the
                                           organization’s activities, financial position and financial results. Client is having a rebound in public and
                                           donor confidence, and is expected to have a clean audit for the most recently concluded financial year.
                                       </p>
                                   </div>
                               </div>
                           </div>
                       </li>
                       <li>
                           <div class="uk-card uk-card-default">
                               <div class="uk-card uk-card-default uk-width-1-1@m">
                                   <div class="uk-card-header">
                                       <div class="uk-grid-small uk-flex-middle" uk-grid>
                                           <div class="uk-width-auto">
                                               <img class="uk-border-circle" width="100" height="100" src="../../../../public/fincor_lion.png">
                                           </div>
                                           <div class="uk-width-expand">
                                               <h5 class=" uk-margin-remove-bottom" style="color: #333 !important;">
                                                   Regulatory Agency with annual budget of over $10 million, agency carried out critical
                                                   function but lacked an accountability framework or an organizational plan linking resource intervention
                                                   to operational and policy objectives.
                                               </h5>
                                               <p class="uk-text-meta uk-margin-remove-top"><time datetime="2016-04-01T19:00">April 01, 2016</time></p>
                                           </div>
                                       </div>
                                   </div>
                                   <div class="uk-card-body " style="margin-top: -15px !important; margin-bottom: -15px !important;" >
                                       <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">How FINCOR was able to help?</h5>
                                       <p>
                                           We worked with management to develop a 5-year strategic plan which
                                           outlined the core focus areas for the organization, the specific resources that will be deployed, and how
                                           success will be measured as the plan progressed.
                                           <br><br>
                                           We also prepared staff performance agreements for over 80 employees which linked their annual
                                           performance and targets with those outlined in the Strategic Plan.
                                       </p>
                                   </div>
                                   <div class="uk-card-footer">
                                       <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">Outcome</h5>
                                       <p>
                                           The Board, and Cabinet, approved the strategic plan, published it on their website and uses it as a tool to
                                           guide the activities of the organization. With the performance agreements we developed, the
                                           organization is now able to do meaningful performance assessments while holding staff accountable for
                                           specific targets. Success for staff is automatically linked to success for the organization.
                                       </p>
                                   </div>
                               </div>
                           </div>
                       </li>

                   </ul>

                   <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slider-item="previous" style="color: rgb(197,179,88) !important;"></a>
                   <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slider-item="next" style="color: rgb(197,179,88) !important;"></a>

               </div>

               <ul class="uk-slider-nav uk-dotnav uk-flex-center uk-margin"></ul>

           </div>
           <div>
               <router-link to="/testimonials" class="uk-button uk-button-secondary uk-text-capitalize uk-align-right">See More Stories</router-link>
           </div>
       </div>
    </div>
</template>

<script>
    export default {
        name: "testimonies"
    }
</script>

<style scoped>

</style>